var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deals-items"},_vm._l((_vm.deals),function(deal){return _c('DealsItem',{key:deal.leadNumber,attrs:{"deal-data":deal}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }